import React, { useEffect } from 'react';
import LoadingComponent from '../../common/LoadingComponent';
import MedicationListItem from './MedicationListItem';
import { sortMedications } from 'helpers/medicationHelpers';
import { medsState, useMedsHistoryStateSnapshot } from 'store/storeValtio';
import { useNavigate } from 'react-router-dom';
import Header from 'components/navigation/Header';

export default function MedicationList() {
  //const medsState = useMedsSnapshot()
  const meds = medsState.meds;
  const medsHistoryState = useMedsHistoryStateSnapshot();
  const navigate = useNavigate();
  //console.log('MedicationList', meds);

  useEffect(() => {
    if (window.startup) window.startup();
    return () => {
      if (window.shutdown) window.shutdown();
    }
  }, [])

  function addMed() {
    navigate('Create');
  }

  if (!medsState.loaded || !medsHistoryState.loaded) return (<LoadingComponent />);
  const medsSort = sortMedications(meds);
  return (
    <div className='mcard'>
      <Header title='Medications' help='MedList' add={addMed} />
      {meds.length === 0 &&
      <div className='w-full flex flex-col justify-center'>
        <div className='text-center my-8'>
          You do not have any medications entered
          <br/>
          Use the link below to add a medication:
        </div>
        <div className='w-full flex justify-center'>
        <button 
          className='bg-blue-200 w-4/12 p-4 rounded-md'
          onClick={()=>navigate('/create')}
        >Add medication</button>
        </div>
      </div>
      }
      {/* <div className='text-lg font-medium text-green-600 bg-gray-200 border rounded mb-2 p-2'>{dt}</div> */}
      <div id='scroll_area' className='lcard'>
        {medsSort.map((m,ix) => {
          return (<MedicationListItem med={m} key={ix} />);
        })}
      </div>
    </div>
  );
}
